import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../redux/types";
import { useNavigate } from "react-router-dom";
import Icons from "../../../../assets/icons/icons";
import { RouteLinks } from "../../../../routes/RouteLinks";
import { encrypt2 } from "../../../../utils/encrypt";
import Skeleton from "react-loading-skeleton";
import {
  formatNumWithCommaNairaSymbol,
  lowerCaseWrap,
  trimLongString,
} from "../../../../helper";
import { RavenToolTip } from "@ravenpay/raven-bank-ui";
import smallTerminalImg from "../../../../assets/small-bankbox-terminal-img.svg";
import "../../../../styles/dashboard/terminals/VirtualTerminalGridViewIndex.css";
import { getVirtualTerminals } from "../../../../redux/insight";
import { useEffect } from "react";
import AllMerchantTerminals from "../AllMerchantTerminals";

const VirtualTerminalGridView = () => {
  const { loading_vir, insights, all_virtual_terminals } = useSelector(
    (state: RootState) => state.insights
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlefetchVirtualTerminal = async () => {
    const obj = {
      name: "",
    };
    const data = await dispatch(getVirtualTerminals(obj as any) as any);

    if (data?.payload?.status === "success") {
      console.log("virtual", data);
    } else {
      // console.error("Request failed:", data);
    }
  };

  useEffect(() => {
    if (Object?.keys(all_virtual_terminals)?.length < 1) {
      handlefetchVirtualTerminal();
    }
  },[]);
  


  return (
    <>
    <AllMerchantTerminals>
    <div className="virtual-terminal-general-wrap-box">
        <div
          style={{
            justifyContent:
              all_virtual_terminals?.data?.length< 4 ? "flex-start" : "space-between",
            display: all_virtual_terminals?.data?.length < 4 ? "flex" : "grid",
          }}
          className="virtiual-card-box-wrap-hold-box "
        >
          {all_virtual_terminals?.data?.map((chi: any, idx: any) => {
            const { account_number,tid_label, cash_in, serial, volume } = chi || {};
            return (
              <div
                className="the-virtual-terminal-box grey-bg"
                style={{
                  minWidth: "32rem",
                }}
              >
                {/* top serial  box start */}
                <div className="top-container-box-holder">
                  <div className="img-terminal">
                    {loading_vir ? (
                      <Skeleton width={35} height={35} circle />
                    ) : (
                      <figure className="img-box">
                        {Icons.virtualTerminal}
                      </figure>
                    )}
                  </div>
                  <div className="virtual-terminalterminal-serial-box">
                    {loading_vir ? (
                      <Skeleton
                        width={70}
                        height={17}
                        style={{ marginBottom: ".3rem" }}
                      />
                    ) : (
                      <p className="terminal">{lowerCaseWrap(tid_label) || "---"}</p>
                    )}
                    {loading_vir ? (
                      <Skeleton width={200} height={11} />
                    ) : (
                      <div className="serial grey-white-color tooltip-hover-wrap">
                        Serial No :{" "}
                        <span>
                          {serial ? trimLongString(serial, 15) : "---"}
                        </span>
                        {serial?.length > 14 && (
                          <RavenToolTip
                            color="deep-green-light"
                            position={`bottom-right`}
                            text={serial}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* top serial  box end */}
                {/* bottom box start */}
                <div className=" card-bg bottom-value-box grey-white-color ">
                  {loading_vir ? (
                    <Skeleton width={100} height={22} />
                  ) : (
                    <div className="bottom-value-box-inner">
                      <div
                        className="bottom-value-box-inner-top"
                        style={{
                          borderBottom: "0.1rem solid #E3E3E3",
                          paddingBottom: "2rem",
                        }}
                      >
                        <div className="img-and-text-box-wrapper">
                          <p className="assignee-box grey-white-color-white ">Account No.</p>
                          <p className="grey-white-color-white ">{account_number?account_number:"----"}</p>
                        </div>
                        <div className="img-terminal grey-bg">
                          <figure className="img-box ">{Icons.threeDot}</figure>
                        </div>
                      </div>

                      <div className="amount-and-volume-box">
                        <p className="volume-count grey-white-color-white ">Cash In • </p>
                        <p className="amount grey-white-color grey-white-color-white ">
                          {formatNumWithCommaNairaSymbol(cash_in) || "0.00"}
                       
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                {/* bottom box end */}
              </div>
            );
          })}
        </div>
      </div>
    </AllMerchantTerminals>
    
    </>
  );
};

export default VirtualTerminalGridView;
